export default __webpack_public_path__ + "static/jcbaey2-gray-707491fc16860feedc6e8c7fbaa8d798.jpg";